import * as React from 'react';
import { useAdyen } from '../../../../../../context/Adyen/context.js';
import '../../../../../../context/PaymentsUI/context.js';
import '@swc/helpers';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import '../../../../../../models/adyen/payment-type.js';
import { AdyenBrands, PaymentMethod } from '../../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../../models/googlePay/types.js';
import '../../../../../../models/payment/types.js';
import '../../../../../../models/paypal/context.js';
import { CreditCardContainer } from '../../../../containers/Adyen/CreditCard/CreditCardContainer.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';

const Creditcard = ({ onChange , config: paymentConfig  })=>{
    const { config  } = useAdyen();
    const creditcardConfig = React.useMemo(()=>{
        const configData = config === null || config === void 0 ? void 0 : config.creditcard;
        if (configData && (paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.brands)) {
            configData.brands = paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.brands;
        }
        return configData;
    }, [
        config,
        paymentConfig
    ]);
    const handleChange = React.useCallback((state)=>{
        let paymentMethodType;
        if (state.cardBrand === AdyenBrands.BANCONTACTMC) {
            paymentMethodType = PaymentMethod.BANCONTACT_CARD;
        }
        // Once Cartes Bancaires is added/requested add transformation here
        onChange(state.data, state.isValid, paymentMethodType);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(CreditCardContainer, {
        onChange: handleChange,
        additionalOptions: creditcardConfig
    });
};

export { Creditcard };
//# sourceMappingURL=Creditcard.js.map
